import React from 'react'

export default function Contact() {
  return (
    <div className='my-5 py-3'>Contact</div>
  )
}
